// Single place for public contact details and official social accounts (mirrors backend seo.py).
export const CONTACT_EMAIL = "videographycapetown@gmail.com";

export const SOCIAL_LINKS = [
  { network: "instagram", label: "Videography Cape Town on Instagram", url: "https://www.instagram.com/videography_cape_town/" },
  { network: "facebook", label: "Videography Cape Town on Facebook", url: "https://www.facebook.com/VideographyCapeTown" },
  { network: "tiktok", label: "Videography Cape Town on TikTok", url: "https://www.tiktok.com/@videographycapetown" },
  { network: "x", label: "Videography Cape Town on X", url: "https://x.com/videographyct" },
  { network: "linkedin", label: "Videography Cape Town on LinkedIn", url: "https://www.linkedin.com/company/videography-cape-town" },
  { network: "google", label: "Find us on Google", url: "https://share.google/iIgBffnQIBJPlJF8v" },
];

export const profileUrl = (p) => `/profile/${p.slug || p.profile_id}`;
export const profileName = (p) => (p.business_name || "").trim() || p.user_name;
